export default __webpack_public_path__ + "static/media/exit.be69d391.png";